import { mapActions } from 'vuex';
import { PriceChangeChart } from '@/utils/chart-models';


export default {
  props: {
    contract: {
      type: Object,
      required: true,
    },
  },
  methods: {
    ...mapActions('chart', ['getContractChartData']),
    createChart(data) {
      if (data) {
        setTimeout(() => {
          this.renderChart(data);
        }, PriceChangeChart.renderTimeout());
      }
    },
    renderChart(data) {
      if (!this.$refs.chart) return;
      const chart = new PriceChangeChart(this.contract, data);
      chart.draw(this.$refs.chart);
    },
  },
  mounted() {
    const payload = {
      contractId: this.contract.contractId,
    };
    this.getContractChartData(payload)
      .then(data => this.createChart(data));
  },
};



// WEBPACK FOOTER //
// ./src/components/market/market-price-change-chart/market-price-change-chart.js